const noStreetNumber = '【無番地】';

/**
 * 「番地が無い場合」ボタン.
 * @param e イベント
 */
const handleNoStreetNumberButtonOnClick = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement;
  if (!target?.dataset?.streetSelector) {
    return;
  }

  const street = document.querySelector(target.dataset.streetSelector) as HTMLInputElement;
  if (street && !street.value?.includes(noStreetNumber)) {
    street.value = street.value + noStreetNumber;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.js-no-street-button');
  buttons.forEach((button: HTMLElement) => {
    button.addEventListener('click', async e => {
      handleNoStreetNumberButtonOnClick(e);
    });
  });
});
